import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { ExpenseType } from "../state/types"

export const useExpenseTypeActions = () => {
    const saveActions = useSaveActions()

    const saveExpenseType = (expenseType: ExpenseType) => {
        const { save } = saveActions()
        return save(TableName.EXPENSE_TYPES, expenseType) as Promise<ExpenseType>
    }

    const removeExpenseType = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.EXPENSE_TYPES, id)
    }

    return {
        saveExpenseType,
        removeExpenseType
    }
}
